import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import InvoiceItemListDetails from '../List Components/InvoiceItemListDetails';
import CreditNoteListDetails from '../List Components/CreditNoteListDetails';
import WaiverListDetails from '../List Components/WaiverListDetails';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import PaymentListDetails from '../List Components/PaymentListDetails';

const SingleInvoiceDetails = () => {
  const { invoiceId } = useParams();
  const decodedId = invoiceId ? atob(invoiceId) : invoiceId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [invoiceDetails, setInvoiceDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {

    fetchInvoiceDetails();
  }, [invoiceId]);

    const fetchCustomerDetails = async (customerId) => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}${customerId}/`, { headers });

        return response.data;
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }
    };

    const fetchInvoiceDetails = async () => {
    try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'customer'];
        const columnsArray = extractedColumns
        .filter((column) => !excludedColumns.includes(column))
        .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
        }));

        if (response.data.customer) {
        const customerResponse = await fetchCustomerDetails(response.data.customer);
        if (customerResponse) {
          //console.log(customerResponse.name)

            response.data.customer_name = customerResponse.name;
            extractedColumns.push('customer_name');
            columnsArray.push({
            label: 'Customer Name',
            field: 'customer_name',
            });
        }
        }

        setColumnDetails(columnsArray);
        setInvoiceDetails(response.data);
    } catch (error) {
        console.error('Error fetching invoice details:', error);
    }
    };

  return (
    <div>
      {invoiceDetails ? (
        <div>
          <SingleItemDetailTemplate details={invoiceDetails} columns={columns} />
          <span>Items</span>
       
          <InvoiceItemListDetails invoice={invoiceDetails.id} />

        <span>Payments</span>
          <PaymentListDetails invoiceId={invoiceDetails.id}/>

          <span>Credit Notes</span>
        <CreditNoteListDetails invoiceId={invoiceDetails.id}/>

        <span>Waivers</span>
          <WaiverListDetails invoiceId={invoiceDetails.id}/>
         
        <button onClick={() => window.location.href = `/payment/input/${invoiceDetails.id}`}>Make Payment</button>

        <button onClick={() => window.location.href = `/credit/note/input/${invoiceDetails.id}`}>Create Credit Note</button>

        <button onClick={() => window.location.href = `/waiver/input/${invoiceDetails.id}`}>Create Waiver</button>

        </div>
      ) : (
        <p>Loading invoice details...</p>
      )}
    </div>
  );
};

export default SingleInvoiceDetails;